export const SaveFollowTypes = Object.freeze({
  BRAND: 'brand',
  PARTNER: 'partner',
  POST: 'post',
  AUTHOR: 'author',
});
